import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, UserPlus } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';

const formatDateTime = (dateString, language) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString(language, {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
};

const CalendrierDetailEmployeesTab = ({ employees, calendarStatus, onNavigateToAffectations }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="space-y-4">
    <div className="flex items-center justify-between">
      <div>
        <h3 className="text-lg font-medium">{t("holidayCalendarComponents.detailEmployees.title", { count: employees.length })}</h3>
        <p className="text-sm text-muted-foreground">{t("holidayCalendarComponents.detailEmployees.desc")}</p>
      </div>
      {calendarStatus === 'APPROVED' && (
        <Button onClick={onNavigateToAffectations}>
          <UserPlus className="mr-2 h-4 w-4" />
          {t("holidayCalendarComponents.detailEmployees.manage")}
        </Button>
      )}
    </div>

    {employees.length === 0 ? (
      <Card>
        <CardContent className="p-6">
          <div className="text-center py-8">
            <Users className="mx-auto h-12 w-12 text-gray-400" />
            <h3 className="mt-2 text-sm font-semibold text-foreground">{t("holidayCalendarComponents.detailEmployees.emptyTitle")}</h3>
            <p className="mt-1 text-sm text-muted-foreground">{t("holidayCalendarComponents.detailEmployees.emptyDesc")}</p>
            {calendarStatus === 'APPROVED' && (
              <div className="mt-6">
                <Button onClick={onNavigateToAffectations}>
                  <UserPlus className="mr-2 h-4 w-4" />
                  {t("holidayCalendarComponents.detailEmployees.assign")}
                </Button>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    ) : (
      <Card>
        <CardContent className="p-0">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{t("holidayCalendarComponents.detailEmployees.matricule")}</TableHead>
                <TableHead>{t("holidayCalendarComponents.detailEmployees.fullName")}</TableHead>
                <TableHead>{t("holidayCalendarComponents.detailEmployees.department")}</TableHead>
                <TableHead>{t("holidayCalendarComponents.detailEmployees.assignedAt")}</TableHead>
                <TableHead>{t("holidayCalendarComponents.detailEmployees.assignedBy")}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {employees.map((emp) => (
                <TableRow key={emp.id}>
                  <TableCell className="font-medium">{emp.registration_number}</TableCell>
                  <TableCell>{emp.first_name} {emp.last_name}</TableCell>
                  <TableCell>{emp.department_name || '-'}</TableCell>
                  <TableCell>{formatDateTime(emp.assigned_at, i18n.language)}</TableCell>
                  <TableCell>{emp.assigned_by || '-'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    )}
    </div>
  );
};

export default CalendrierDetailEmployeesTab;
